import styled from 'styled-components';
import { CardContent } from '@material-ui/core';

export const StyledContent = styled(CardContent)`
  && {
    display: flex;
  }
`;